var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item",
      class: {
        item2:
          _vm.type == 3 ||
          _vm.type == 4 ||
          _vm.type == 5 ||
          _vm.type == 6 ||
          _vm.type == 10,
        item3: _vm.type == 7,
        item8: _vm.type == 8,
        item9: _vm.type == 9,
      },
      on: {
        click: function ($event) {
          return _vm.lookDetails(_vm.item)
        },
      },
    },
    [
      _vm.type == 1
        ? _c("div", { staticClass: "img" }, [
            _c("img", {
              attrs: {
                src: _vm.item.courseImage ? _vm.item.courseImage : _vm.notImg,
              },
              on: { error: _vm.handleImageError },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type == 10
        ? _c("div", { staticClass: "img10" }, [
            _c("img", {
              attrs: {
                src: _vm.item.coverLogo ? _vm.item.coverLogo : _vm.notImg,
              },
              on: { error: _vm.handleImageError },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type != 1 && _vm.type != 9 && _vm.type != 10
        ? _c("div", { staticClass: "img2" }, [
            _c("img", {
              attrs: {
                src: _vm.item.courseImage ? _vm.item.courseImage : _vm.notImg,
              },
              on: { error: _vm.handleImageError },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type == 9
        ? _c("div", { staticClass: "img3" }, [
            _vm.item.courseImage ==
            "https://file.icve.com.cn/sso/zwfm/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20230320140803.png"
              ? _c("img", {
                  staticClass: "i1",
                  attrs: { src: _vm.item.courseImage },
                  on: { error: _vm.handleImageError },
                })
              : _c("img", {
                  staticClass: "i2",
                  attrs: {
                    src: _vm.item.courseImage
                      ? _vm.item.courseImage
                      : _vm.notImg,
                  },
                  on: { error: _vm.handleImageError },
                }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mainText" }, [
        _vm.type == 1 ? _c("div", { staticClass: "line" }) : _vm._e(),
        _vm._v(" "),
        _vm.type != 9
          ? _c("div", { staticClass: "tit" }, [
              _vm._v(_vm._s(_vm.item.courseName)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 9
          ? _c("div", { staticClass: "titBook" }, [
              _vm._v(_vm._s(_vm.item.courseName)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type != 9 && _vm.type != 5
          ? _c("div", { staticClass: "sourse" }, [
              _c("img", {
                attrs: { src: require("../assets/img/image/xuexiao.png") },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.item.fkCourseEmceeSchool ||
                        _vm.item.courseInfoName ||
                        ""
                    ) +
                    "\n      "
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 1 || _vm.type == 8
          ? _c("div", [
              _c("div", { staticClass: "sourse" }, [
                _c("div", { staticClass: "text_w" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.item.courseEmceeName ? _vm.item.courseEmceeName : ""
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }, [
                _c("div", { staticClass: "text_w" }, [
                  _vm._v(_vm._s(_vm.item.industry ? _vm.item.industry : "---")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }, [
                _c("div", { staticClass: "text_w" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.item.industryDetailName
                          ? _vm.item.industryDetailName
                          : "---"
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }, [
                _c("div", { staticClass: "text_w" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.item.fkCourseMajor ? _vm.item.fkCourseMajor : "---"
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }, [
                _c("img", {
                  attrs: { src: require("../assets/img/icon-origin.png") },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _vm._v("来源: " + _vm._s(_vm.item.origin)),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 2
          ? _c("div", [
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-period.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("date")(_vm.item.createTime)) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-teacher.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.courseEmceeName) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.item.studyNum
                  ? _c("div", { staticClass: "name name2" }, [
                      _c("img", {
                        attrs: { src: require("../assets/img/icon-see.png") },
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.item.studyNum) +
                          "人\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 3
          ? _c("div", [
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-teacher.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.courseEmceeName) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-origin.png") },
                  }),
                  _vm._v(
                    "\n          来源：" +
                      _vm._s(_vm.item.origin) +
                      "\n        "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 4 || _vm.type == 6
          ? _c("div", [
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-teacher.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.courseEmceeName) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "name name2" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.item.majorCatId) + "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/image/share.png") },
                  }),
                  _vm._v(
                    "\n          来源：" +
                      _vm._s(_vm.item.origin) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.type == 4 && _vm.item.studyNum
                  ? _c("div", { staticClass: "name name2" }, [
                      _c("img", {
                        attrs: { src: require("../assets/img/icon-see.png") },
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.item.studyNum) +
                          "人\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 5
          ? _c("div", [
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/image/xuexiao.png") },
                  }),
                  _vm._v(
                    _vm._s(
                      _vm.item.fkCourseEmceeSchool
                        ? _vm.item.fkCourseEmceeSchool
                        : "---"
                    ) + "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/people.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.courseEmceeName) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/image/list4.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.fkCourseMajor) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }, [
                _c("img", {
                  attrs: { src: require("../assets/img/image/share.png") },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _vm._v("来源: " + _vm._s(_vm.item.origin)),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 7
          ? _c("div", [
              _c("div", { staticClass: "text_w" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-teacher.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.courseEmceeName) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "line2" }),
                _vm._v(" "),
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/image/share.png") },
                  }),
                  _vm._v(
                    "\n          来源：" +
                      _vm._s(_vm.item.origin) +
                      "\n        "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 9
          ? _c("div", [
              _vm.type == 9 ? _c("div", { staticClass: "sourse" }) : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 10
          ? _c("div", [
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/people.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.presidingTeacher || "---") +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/image/hangye.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.courseInfoTypeName || "---") +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.item.flag
                ? _c("div", { staticClass: "text2" }, [
                    _c("div", { staticClass: "name" }, [
                      _c("img", {
                        staticStyle: { width: "16px" },
                        attrs: {
                          src: require("../assets/img/image/shijian.png"),
                        },
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            ["即将开始", "进行中", "已结束"][_vm.item.flag - 1]
                          ) +
                          "\n          "
                      ),
                      _vm.item.flag == "2" && _vm.item.weekNumber != null
                        ? _c("span", [
                            _vm._v("(第" + _vm._s(_vm.item.weekNumber) + "周)"),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "sourse" }, [
                _c("img", {
                  staticStyle: { width: "18px", "margin-bottom": "2px" },
                  attrs: { src: require("../assets/img/image/shijian2.png") },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.item.startTime + "至" + _vm.item.endTime)),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }